<template>
	<div
		:class="[
			`${arrowDirectionStyle} ${height}  w-6 flex items-center top-0 absolute z-20 bg-white bg-opacity-50 cursor-pointer`
		]"
	>
		<ChevronRightIcon
			:class="[`h-6 w-6 text-black ${disable(scrollPosition) && 'opacity-50'}`]"
		/>
	</div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { ChevronRightIcon } from "@heroicons/vue/24/outline";

interface Props {
	arrowDirection: string;
	numberOfSlidesToShow: string;
	scrollPosition: number;
	numberOfSlides: number;
}

const { arrowDirection, numberOfSlidesToShow, scrollPosition, numberOfSlides } =
	defineProps<Props>();

const height = computed(() => {
	if (numberOfSlidesToShow === "6") {
		return "min-h-45";
	}
	return "min-h-72.5";
});

const disable = (scrollPosition: number) => {
	if (scrollPosition <= 0 && arrowDirection === "left") {
		return true;
	}

	if (arrowDirection === "right") {
		const widthOfSlides = numberOfSlidesToShow === "6" ? 190 : 288;
		const maximumScrollSize = numberOfSlides * widthOfSlides;
		const widthOfFirstSlides = widthOfSlides * +numberOfSlidesToShow;

		return maximumScrollSize - widthOfFirstSlides < scrollPosition;
	}
};

const arrowDirectionStyle = computed(() => {
	return arrowDirection === "left" ? "left-0 rotate-180" : "right-0";
});
</script>
